// extracted by mini-css-extract-plugin
module.exports = {"coinContainer":"Landing_coinContainer__11Q-q","input":"Landing_input__1IsCm"};